module.exports = __webpack_public_path__ + "static/media/04-thumbnail.80c8ff5c.jpg";